import React, { useState } from "react";
import { makeStyles } from "@material-ui/core";
import DatePicker from "react-datepicker";
import { QueryFilterValue } from "../../types";

import "react-datepicker/dist/react-datepicker.css";
import { format } from "date-fns";

export type DateRangeTableFilterProps = {
  filter: TableFilterDateRangeType;
  onFilterChange: (filterValue: QueryFilterValue) => void;
};

export type TableFilterDateRangeType = {
  type: "date-range";
  name: string;
  label: string;
};

const useStyles = makeStyles(theme => ({
  container: {
    margin: theme.spacing(1),
    marginTop: theme.spacing(3),
    minWidth: 120
  }
}));

export const DateRangeTableFilter = ({
  filter,
  onFilterChange
}: DateRangeTableFilterProps) => {
  const classes = useStyles();
  const [dateRange, setDateRange] = useState<{
    startDate: Date | null;
    endDate: Date | null;
  }>({
    startDate: null,
    endDate: null
  });
  const { startDate, endDate } = dateRange;

  return (
    <div className={classes.container}>
      <DatePicker
        placeholderText={filter.label}
        dateFormat="dd/MM/yyyy"
        selectsRange={true}
        startDate={startDate}
        endDate={endDate}
        onChange={update => {
          setDateRange({ startDate: update[0], endDate: update[1] });
          onFilterChange({
            from: update[0] ? format(update[0], "yyyy-MM-dd") : undefined,
            to: update[1] ? format(update[1], "yyyy-MM-dd") : undefined
          });
        }}
        isClearable
      />
    </div>
  );
};
